
export const toggleDrawer = () => ({type: 'TOGGLE_DRAWER'});

export const closeDrawer = () => ({type: 'CLOSE_DRAWER'});

export const refreshCurrentPage = () => ({type: 'REFRESH_CURRENT_PAGE'});

export const openEndingPanel = (id) => ({type: 'OPEN_ENDING_PANEL', id})

export const setLocale = (locale) => ({
  type: 'SET_LOCALE',
  locale,
});